import { render } from "./Rater.vue?vue&type=template&id=20d09001&scoped=true"
import script from "./Rater.vue?vue&type=script&lang=js"
export * from "./Rater.vue?vue&type=script&lang=js"

import "./Rater.vue?vue&type=style&index=0&id=20d09001&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d09001"]])

export default __exports__